/*
    Shared status helpers.
    Internal keys are English; labels remain Spanish because they are UI copy.
*/

export const onNormalizeStatus = (status) => (
    String(status ?? '')
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_')
);

export const STATUS_MAP_DEFAULT = {
    // Lifecycle
    active: { label: 'Activo', tone: 'ok' },
    inactive: { label: 'Inactivo', tone: 'neutral' },
    draft: { label: 'Borrador', tone: 'neutral' },
    published: { label: 'Publicado', tone: 'ok' },
    archived: { label: 'Archivado', tone: 'neutral' },
    deleted: { label: 'Eliminado', tone: 'danger' },

    // Approval / workflow
    pending: { label: 'Pendiente', tone: 'warn' },
    in_progress: { label: 'En proceso', tone: 'accent' },
    in_review: { label: 'En revisión', tone: 'accent' },
    approved: { label: 'Aprobado', tone: 'ok' },
    rejected: { label: 'Rechazado', tone: 'danger' },
    cancelled: { label: 'Cancelado', tone: 'danger' },

    // Payments
    paid: { label: 'Pagado', tone: 'ok' },
    unpaid: { label: 'Impago', tone: 'danger' },
    overdue: { label: 'Vencido', tone: 'danger' },
    partial: { label: 'Pago parcial', tone: 'warn' },
    refunded: { label: 'Reintegrado', tone: 'neutral' },

    // Connectivity
    online: { label: 'En línea', tone: 'ok' },
    offline: { label: 'Desconectado', tone: 'neutral' },
    error: { label: 'Error', tone: 'danger' },
};

export const onBuildStatusMap = (extra = {}, { base = STATUS_MAP_DEFAULT } = {}) => {
    const result = { ...base };

    Object.entries(extra).forEach(([key, config]) => {
        result[onNormalizeStatus(key)] = config;
    });

    return result;
};

export const onResolveStatus = (status, map = STATUS_MAP_DEFAULT, fallbackTone = 'neutral') => {
    const key = onNormalizeStatus(status);
    const found = map[key];

    if (found) return { key, tone: 'neutral', ...found, isKnown: true };

    return {
        key,
        label: String(status ?? '—'),
        tone: fallbackTone,
        isKnown: false,
    };
};
